function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return "";
}

// Track User's Recently Viewed Products
if (window.location.pathname.includes("/products/")) {
  const recentlyViewedCookie = "shopify_recently-viewed-products";

  const productHandle = window.location.pathname.replace("/products/", "");

  console.log("this product is");
  console.log(productHandle);

  // Fetch 'Collection' products.
  fetch(`/products/${productHandle}.js`)
    .then(function (response) {
      if (response.ok) {
        const currentCookie = getCookie(recentlyViewedCookie);
        const cookieArray = currentCookie.split("/");

        if (currentCookie.length == 0) {
          setCookie(recentlyViewedCookie, productHandle, 365);
        } else if (!currentCookie.includes(productHandle)) {
          var newValue = currentCookie + "/" + productHandle;

          if (cookieArray.length > 15) {
            newValue = newValue.replace(cookieArray[0] + "/", "");
          }

          setCookie(recentlyViewedCookie, newValue, 365);
        }
      }
      return response;
    })
    .catch(function (error) {
      console.log(error);
    });
}
